import { BaseModel } from './BaseModel';

export interface ModpackAuthor {
    id: string;
    name?: string;
}

export interface ModpackBuildCounts {
    queued: number;
    running: number;
    onDemand: number;
    failed: number;
    succeeded: number;
    total: number;
}

export class Modpack extends BaseModel {
    public platform = '';
    public id = '';
    public name = '';
    public description = '';
    public thumbnailUrl = '';
    public websiteUrl = '';
    public downloads = -1;
    public updatedAt = '';

    // Only returned by the admin modpack lookup endpoint.
    public authors: ModpackAuthor[] = [];
    public counts: ModpackBuildCounts | null = null;
}
